module.exports = __webpack_public_path__ + "static/media/user.c1c9b36b.jpg";